import React from 'react';
import styled from "styled-components";
import {isEmpty} from "@helpers/helpers";

let collapseTimeOut = undefined;
const Accordion = ({itemKey, title, content}) => {

    const getElementHeight = (element) => {
        let height = 0;

        element.classList.add('show');
        height = element.scrollHeight;
        element.classList.remove('show');

        return height;
    };

    const handleShowCollapse = (e, id) => {
        if (!isEmpty(e.target)) {
            const accordion = e.target.closest('.accordion');
            const current = '.c-' + id;
            const allCollapseToggles = accordion.querySelectorAll('.collapse-toggle');
            const allCollapses = accordion.querySelectorAll('.collapse:not(' + current + ')');
            const currentCollapse = accordion.querySelector(current);

            if (allCollapseToggles.length) {
                for (let toggle of allCollapseToggles) {
                    toggle.classList.remove('collapsed');
                }
            }

            if (allCollapses.length) {
                for (let collapseTag of allCollapses) {
                    collapseTag.style.height = 0;

                    setTimeout(() => {
                        collapseTag.classList.remove('show')
                    }, 500)
                }
            }

            if (!isEmpty(currentCollapse)) {
                if (currentCollapse.classList.contains('show')) {
                    currentCollapse.style.height = 0;

                    if (!isEmpty(collapseTimeOut)) {
                        clearTimeout(collapseTimeOut);
                    }

                    collapseTimeOut = setTimeout(() => {
                        currentCollapse.classList.remove('show')
                    }, 500)
                } else {
                    currentCollapse.style.height = getElementHeight(currentCollapse) + 'px';

                    currentCollapse.classList.add('show');
                    e.target.classList.add('collapsed');
                }
            }
        }
    };

    return (
        <Card className="border-bottom-gray-200" key={itemKey}>
            <Header className="h3 collapse-toggle py-24 d-flex align-items-start align-items-lg-center justify-content-between font-weight-500" onClick={(e) => handleShowCollapse(e, itemKey)} role="button">
                {title}
            </Header>

            <Content className={"collapse " + ('c-' + itemKey)}>
                <div className="pb-24 collapse-content" dangerouslySetInnerHTML={{__html: content}}/>
            </Content>
        </Card>
    );
};

export default React.memo(Accordion);

// styles
const Card = styled.div`
    &:last-child {
        border-bottom: 0;
    }
`;

const Header = styled.div`
    &:after {
        content: url('/_img/icons/chevron-down.svg');
        width: 14px;
        min-width: 14px;
        max-width: 14px;
        height: 14px;
        min-height: 14px;
        max-height: 14px;
        margin-right: 24px;
    }
    
    &.collapsed:after {
        content: url('/_img/icons/chevron-up.svg');
    }
`;

const Content = styled.div`
    height: 0;
    transition: height .4s cubic-bezier(0.31, 0.79, 0.35, 0.82);
    overflow :hidden;
    will-change :height;
`;